import React from "react";
import { Link } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { landingShellContainerSx } from "./auth/authScreenStyles";
import { productBrand } from "../productBrand";

/** Matches packages/frontend MainNavbar shell (invite landing chrome). */
const LANDING_NAVBAR_FONT = productBrand.wordmarkFontFamily;

const NavbarContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: 1000,
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}));

export type AuthNavbarVariant = "default" | "landing";

export interface AuthNavbarProps {
  variant?: AuthNavbarVariant;
}

const AuthNavbar: React.FC<AuthNavbarProps> = ({ variant = "default" }) => {
  if (variant === "landing") {
    return (
      <Box
        component="header"
        sx={{
          position: "sticky",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          bgcolor: "background.default",
          color: "text.primary",
          flexShrink: 0,
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            ...landingShellContainerSx,
            py: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            component="a"
            href={productBrand.marketingUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontFamily: LANDING_NAVBAR_FONT,
              fontWeight: 800,
              fontSize: { xs: "1.35rem", md: "1.5rem" },
              color: "inherit",
              textDecoration: "none",
              "&:hover": { opacity: 0.92 },
            }}
          >
            {productBrand.name}
          </Typography>
        </Container>
      </Box>
    );
  }

  return (
    <NavbarContainer>
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: { xs: 2, md: 4 },
          my: -3,
          py: 1,
          bgcolor: "background.default",
        }}
      >
        <Typography
          variant="h1"
          component={Link}
          to="/auth"
          sx={{
            textDecoration: "none",
            color: "primary.main",
            fontWeight: 800,
            fontSize: { xs: "1.75rem", md: "2rem" },
          }}
        >
          {productBrand.name}
        </Typography>
      </Container>
    </NavbarContainer>
  );
};

export default AuthNavbar;
